// extracted by css-extract-rspack-plugin
export default {"filterIndicator":"CommentsFilter-module__filterIndicator__QFaHH"};